module.exports = __webpack_public_path__ + "media/bundles/ReactHome/components/layout/images/slide2-408c95e17d36d4f417eec125b1c48a25.jpg";